import React from 'react';

import dayjs from '~/timeInit';

import { Box } from '@mui/material';
import type { DateRange } from '@mui/x-date-pickers-pro';
import { DateRangePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';

import type { Dayjs } from '~/services/TimeService';

const DEFAULT_SEARCH_START_DAYS_AGO = 2;
const DEFAULT_SEARCH_END_DAYS_AGO = 1;
const DEFAULT_DATE_INPUT_WIDTH = 160;

export function getDefaultSearchDateRange(): DateRange<Dayjs> {
  return [
    dayjs().subtract(DEFAULT_SEARCH_START_DAYS_AGO, 'day').startOf('day'),
    dayjs().subtract(DEFAULT_SEARCH_END_DAYS_AGO, 'day').endOf('day'),
  ];
}

export function toBigQueryExclusiveEndDate(inclusiveEnd: Dayjs) {
  return inclusiveEnd.add(1, 'day').format('YYYY-MM-DD');
}

export function toInclusiveEndDate(exclusiveEnd: string) {
  return dayjs(exclusiveEnd).subtract(1, 'day').format('YYYY-MM-DD');
}

type Props = {
  dateRange: DateRange<Dayjs>;
  onChange: (value: DateRange<Dayjs>) => void;
  children?: React.ReactNode;
  dateInputWidth?: number;
};

export default function SearchBigQueryDateRangePicker({ dateRange, onChange, children, dateInputWidth }: Props) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          alignItems: 'center',
          display: 'grid',
          gap: 2,
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 520px), 1fr))',
          width: '100%',
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <DateRangePicker
            value={dateRange}
            onChange={onChange}
            format="DD/MM/YYYY"
            localeText={{ start: 'Search BQ from', end: 'until' }}
            slotProps={{
              textField: {
                size: 'small',
                required: true,
                sx: { width: dateInputWidth ?? DEFAULT_DATE_INPUT_WIDTH },
              },
            }}
          />
        </Box>
        {children}
      </Box>
    </LocalizationProvider>
  );
}
